import { create } from 'zustand';

export const useLabTestStore = create((set) => ({
    validCity: false,
    validatingCity: false,
    updateValidCity: (isValid) => set(state => ({...state, validCity: isValid})),
    updateValidatingCity: (validating) => set(state => ({...state, validatingCity: validating}))
}));